export default __webpack_public_path__ + "static/O0258-d09bebda324a30ec7140be6cf9f1c5f6.png";